import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useGoogleAnalytics() {
    const location = useLocation();

    useEffect(() => {
        if (!window.gtag) return;

        window.gtag("event", "page_view", {
            page_path: location.pathname,
            page_title: document.title,
        });
    }, [location.pathname]);
}
